import { create } from "zustand"
import { devtools } from "zustand/middleware"
import { immer } from "zustand/middleware/immer"

import { FormattedDirectoryItem } from "../schema/directory.schema"

type File = {
  id?: string;
  label?: string;
  size?: number | string;
  uploadedBy?: string;
  uploadDate?: string;
  lastUpdate?: string;
  type?: string;
  file_type?: string;
  url?: string;
  category_id?: string;
  owner_name?: string;
}

type Folder = {
  id?: string;
  label?: string;
  slug?: string;
  name?: string;
  category_id?: string;
  file_type?: string;
}

export type BreadcrumbItem = {
  name: string;
  slug: string;
}

type Breadcrumb = BreadcrumbItem[]

type appState = {
  theme: "light" | "dark";
  uploadFileProgress: number;
  SelectedItems: FormattedDirectoryItem[];
  File: File;
  Folder: Folder;
  Breadcrumb: Breadcrumb;
  sidebarCollapse: boolean;
  TypeSelected: "Folder" | "File";
  isOpenModalDetail: boolean;
  sharedPeopleAndDivisions: SharedPeopleDivisions;
}

export type SharedPeopleDivisions = {
  isLoading: boolean | undefined;
  shared: Shared[];
}
export interface Shared {
  id: string;
  fullName?: string;
  email?: string;
  photo?: null | string;
  type: Type;
  permissions: Permissions;
  text?: string;
  team?: number;
}

export enum Permissions {
  Edit = "edit",
  Owner = "owner",
  View = "view",
}

export enum Type {
  Division = "division",
  User = "user",
}

type Actions = {
  setTheme: (theme: "light" | "dark") => void;
  setUploadFileProgress: (progress: number) => void;
  detail: (file: File) => void;
  getBreadcrumb: (breadcrumb: Breadcrumb) => void;
  setSidebarCollapse: (sidebarCollapse: boolean) => void;
  setFolderDetail: (folder: Folder) => void;
  setTypeSelected: (type: "Folder" | "File") => void;
  setIsOpenModalDetail: (isOpen: boolean) => void;
  setSelectedItems: (selected: FormattedDirectoryItem[]) => void;
  setSharedPeopleAndDivisions: (data: SharedPeopleDivisions) => void;
}

export const useStoreApp = create<appState & Actions>()(
  devtools(
    immer((set) => ({
      theme: "light",
      uploadFileProgress: 0,
      SelectedItems: [],
      sharedPeopleAndDivisions: {
        shared: [],
        isLoading: undefined,
      },
      sidebarCollapse: false,
      File: {
        label: "",
        size: 0,
        uploadedBy: "",
        uploadDate: "",
        lastUpdate: "",
        type: "",
      },
      Folder: {},
      TypeSelected: "Folder",
      Breadcrumb: [],
      isOpenModalDetail: false,
      setTheme: (theme: "light" | "dark") =>
        set((state) => {
          state.theme = theme
        }),
      setUploadFileProgress: (progress: number) =>
        set((state) => {
          state.uploadFileProgress = progress
        }),
      setSharedPeopleAndDivisions: (data: SharedPeopleDivisions) =>
        set((state) => {
          state.sharedPeopleAndDivisions = data
        }),
      getBreadcrumb: (breadcrumb: Breadcrumb) =>
        set((state) => {
          state.Breadcrumb = breadcrumb
        }),
      detail: (file: File) =>
        set((state) => {
          state.File = file
        }),
      setSidebarCollapse: (sidebarCollapse: boolean) =>
        set((state) => {
          state.sidebarCollapse = sidebarCollapse
        }),
      setFolderDetail: (folder: Folder) =>
        set((state) => {
          state.Folder = folder
        }),
      setTypeSelected: (type: "Folder" | "File") =>
        set((state) => {
          state.TypeSelected = type
        }),
      setIsOpenModalDetail: (isOpen: boolean) =>
        set((state) => {
          state.isOpenModalDetail = isOpen
        }),
      setSelectedItems: (selected: FormattedDirectoryItem[]) =>
        set((state) => {
          state.SelectedItems = selected
        }),
    })),
    { name: "AppStore" }
  )
)
